import angular from 'angular';

FavoritesIndexSidebar.$inject = [
    'localFavorites',
    'tn.favorites.filters.service',
    '$scope',
];

export function FavoritesIndexSidebar(localFavorites, favFilters, $scope) {
    angular.extend(this, {
        activeFilters: favFilters.get(),
        toggleFilter: favFilters.toggle,
        clearFilter: favFilters.reset,
        clearFilters: favFilters.resetAll,
        isActive: { date: true },
        favorites: localFavorites.getFavorites(),
        filteredFavorites: localFavorites.getFilteredFavorites(),
    });

    initialize();

    function initialize() {
        $scope.$watch(
            'vm.activeFilters',
            function (newFilters) {
                localFavorites.setFilters(newFilters);
            },
            true
        );
    }
}
